import React from 'react';
import { InputNumber } from 'primereact/inputnumber';
import { InputText } from 'primereact/inputtext';
import { useLanguage } from '../../../../contexts/LanguageContext';

const PaymentAmountSection = ({ amount, currency, onAmountChange, onCurrencyChange, errors, submitted, disabled }) => {
    const { th } = useLanguage();

    return (
        <div className="surface-card p-4 border-round-xl shadow-1 mb-4">
            <div className="flex align-items-center mb-4">
                <i className="pi pi-wallet text-2xl text-primary mr-3"></i>
                <h3 className="m-0 text-xl font-semibold">{th('creditCardCollection.sections.paymentAmount') || 'Ödeme Tutarı'}</h3>
            </div>

            <div className="grid">
                {/* Tutar */}
                <div className="col-12 md:col-6">
                    <label htmlFor="amount" className="block text-900 font-medium mb-2">
                        {th('creditCardCollection.fields.amount') || 'Tutar'} <span className="text-red-500">*</span>
                    </label>
                    <InputNumber
                        id="amount"
                        value={amount}
                        onValueChange={(e) => onAmountChange(e.value)}
                        mode="decimal"
                        maxFractionDigits={2}
                        min={0}
                        className={`w-full ${submitted && errors?.amount ? 'p-invalid' : ''}`}
                        placeholder={th('creditCardCollection.placeholders.amount') || 'Ödeme tutarını giriniz'}
                        disabled={disabled}
                        locale="tr-TR"
                    />
                    {submitted && errors?.amount && <small className="p-error block mt-1">{errors.amount}</small>}
                </div>

                {/* Para Birimi - userParams'tan gelen dealerCurrency'ye göre */}
                <div className="col-12 md:col-6">
                    <label htmlFor="currency" className="block text-900 font-medium mb-2">
                        {th('creditCardCollection.fields.currency') || 'Para Birimi'} <span className="text-red-500">*</span>
                    </label>
                    <InputText
                        id="currency"
                        value={currency || ''}
                        className="w-full"
                        disabled
                    />
                </div>
            </div>
        </div>
    );
};

export default React.memo(PaymentAmountSection);

